export default class RequestMethod {

    static OPTIONS = 'OPTIONS';
    static GET = 'GET';
    static HEAD = 'HEAD';
    static POST = 'POST';
    static PUT = 'PUT';
    static DELETE = 'DELETE';
    static PATCH = 'PATCH';
    static TRACE = 'TRACE';
    static CONNECT = 'CONNECT';
}


export class ResponseType {
    static JSON = 'json';
    static ARRAYBUFFER = 'arraybuffer';
}